<tail-color [(value)]="value.color"></tail-color>
<tail-image-upload class="pt-2" [(value)]="value.url"></tail-image-upload>
<p tailHint variant="red-500" i18n="@@value_image_outlook_support">
  Background image has limited support in some Outlook versions.
</p>

<ng-container *ngIf="value.url.length">
  <h3 tailH3 i18n="@@value_image_repeat" class="pt-2">Background image repeat</h3>
  <div class="grid grid-cols-4 gap-2">
    <button *ngFor="let repeat of repeatKeys" tailBtn size="xs"
            [class.active]="value.repeat === repeat"
            (click)="value.repeat = repeat"
    >
      {{getRepeatLabel(repeat)}}
    </button>
  </div>
  <h3 tailH3 i18n="@@value_image_size" class="pt-2">Background image size</h3>
  <div class="grid grid-cols-5 gap-2">
    <button tailBtn size="xs" [class.active]="value.size.auto"
            (click)="value.size.auto = !value.size.auto" i18n="@@value_image_size_auto">
      Auto
    </button>
    <button *ngFor="let unit of value.size.units" tailBtn size="xs"
            [class.active]="value.size.unit === unit && !value.size.auto"
            (click)="value.size.unit = unit"
            [disabled]="value.size.auto"
    >
      {{getUnitLabel(unit)}}
    </button>
  </div>

  <div class="mt-1" *ngIf="['%', 'px'].includes(value.size.unit) && !value.size.auto">
    <input type="number" tailInput [(ngModel)]="value.size.value">
  </div>
</ng-container>
